export default {
    CSACountUserSaveSettings: {
        datapoint: {
            name: 'CSACountUserSaveSettings',
            customData: function (readStaticCount, readAddinCount, composeStaticCount, composeAddinCount) { return [
                readStaticCount,
                readAddinCount,
                composeStaticCount,
                composeAddinCount,
            ]; },
        },
    },
};
//# sourceMappingURL=datapoints.js.map